/**
 * Los encabezados de los calendarios de vacaciones: sólo de lunes a viernes.
 * El fin de semana no se trabaja, no se descuenta y no se pinta (pedido de
 * Norman, 24/09/2026: «si no se trabajan fines de semana, mejor quítalos»).
 */
export const DIAS_HABILES = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];

/**
 * Las semanas de un mes, de lunes a viernes.
 *
 * Cada semana trae cinco celdas: `dia(fecha)` para los días del mes y
 * `vacia()` para los huecos antes del 1 y después del último. Una semana
 * cuyos cinco días hábiles son de otro mes no sale: un mes que empieza en
 * sábado no abre con una fila vacía, ni uno que termina en domingo cierra
 * con otra. Por eso salen cuatro o cinco semanas, no siempre seis.
 */
export function semanasHabiles<T>(
  anio: number,
  mes: number,
  dia: (fecha: Date) => T,
  vacia: () => T,
): T[][] {
  const primero = new Date(anio, mes, 1);
  // getDay() da 0 para domingo; aquí la semana empieza en lunes.
  const lunes = 1 - ((primero.getDay() + 6) % 7);
  const semanas: T[][] = [];
  for (let s = 0; s < 6; s++) {
    const semana: T[] = [];
    let delMes = false;
    for (let d = 0; d < 5; d++) {
      const fecha = new Date(anio, mes, lunes + s * 7 + d);
      if (fecha.getMonth() === mes) {
        semana.push(dia(fecha));
        delMes = true;
      } else {
        semana.push(vacia());
      }
    }
    if (delMes) {
      semanas.push(semana);
    }
  }
  return semanas;
}
